import script from "./happy.vue?vue&type=script&lang=ts&setup=true"
export * from "./happy.vue?vue&type=script&lang=ts&setup=true"

import "./happy.vue?vue&type=style&index=0&id=bc206360&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc206360"]])

export default __exports__